/* unplugin-vue-components disabled */import { render } from "./uploadfile.vue?vue&type=template&id=3c1719cf&scoped=true"
import script from "./uploadfile.vue?vue&type=script&lang=js"
export * from "./uploadfile.vue?vue&type=script&lang=js"

import "./uploadfile.vue?vue&type=style&index=0&id=3c1719cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1719cf"]])

export default __exports__